<ui-page-container size="small">
  <mat-card>
    <mat-card-title>
      {{ (entityId ? 'Modifica ruolo' : 'Aggiungi rouolo') | translate }}
    </mat-card-title>
    <mat-card-content>
      <form
        *ngIf="entityForm"
        [formGroup]="entityForm"
        (ngSubmit)="dispatchAction(entityForm)">
        <mat-form-field class="input-expanse">
          <input
            class="input-expanse"
            type="text"
            name="name"
            matInput
            formControlName="name"
            [placeholder]="'Nome' | translate">
        </mat-form-field>
        <mat-error
          class="message-error"
          *ngIf="entityControls?.name?.touched && entityControls?.name?.hasError('required')">
          {{ 'Nome obbligatorio' | translate }}
        </mat-error>

        <div
          class="capability-container">
          <h2>{{ 'Gestione permessi' | translate }}</h2>
          <mat-form-field>
            <input
              type="text"
              matInput
              name="searchCapability"
              #searchCapabilityInput
              [placeholder]="'Cerca permessi' | translate">
          </mat-form-field>
          <div>
            <mat-checkbox
              class="capability-item"
              *ngFor="let c of capabilities$ | async | filterObj : 'name' : searchCapabilityInput.value; let i = index"
              [value]="c.id"
              [checked]="entityControls?.capabilities?.value | checkCapability : c.name"
              (change)="toggleCapability($event, c)">
              {{ c.name }}
            </mat-checkbox>
          </div>
        </div>

        <div class="role-actions">
          <button
            mat-raised-button
            color="primary"
            type="submit">
            {{ (entityId ? 'Modifica' : 'Aggiungi') | translate }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ui-page-container>
